export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7286.c126db3e.jpg";